import gsap from "gsap";

const Accordion = {
	el: {
		root: document.querySelectorAll(".accordion"),
	},

	init() {
		if (this.el.root) {
			this.el.root.forEach((target) => {
				const el = {
					items: target.querySelectorAll(".accordion-item"),
				};

				if (el.items) {
					Array.prototype.forEach.call(el.items, (item) => {
						const accordionHead = item.querySelector(".accordion-item__head");
						const links = item.querySelectorAll("a");

						links.forEach((link) => {
							link.tabIndex = -1;
						});

						accordionHead.addEventListener("click", this.toggleItem);
						accordionHead.addEventListener(
							"keydown",
							(event: KeyboardEvent) => {
								if (event.key === "Enter") {
									this.toggleItem(event);
								}
							},
						);
					});
				}
			});
		}

		this.scrollToFragment();
	},

	closeItem: (accordionItem) => {
		const accordionBody = accordionItem.querySelector(".accordion-item__body");
		const links = accordionItem.querySelectorAll("a");
		accordionBody.tabIndex = -1;

		links.forEach((link) => {
			link.tabIndex = -1;
		});

		gsap.to(accordionBody, {
			clearProps: "all",
			duration: 0.5,
			ease: "power3.inOut",
			height: 0,
			opacity: 0,
			onStart: () => {
				accordionItem.classList.remove("accordion-item--selected");
			},
		});
	},

	openItem: (accordionItem) => {
		const accordionBody = accordionItem.querySelector(".accordion-item__body");
		accordionBody.tabIndex = 0;

		const links = accordionItem.querySelectorAll("a");

		links.forEach((link) => {
			link.tabIndex = 0;
		});

		gsap.fromTo(
			accordionBody,
			{
				height: 0,
				opacity: 0,
			},
			{
				clearProps: "all",
				duration: 0.5,
				ease: "power3.inOut",
				height: "auto",
				opacity: 1,
				onStart: () => {
					accordionItem.classList.add("accordion-item--selected");
				},
			},
		);
	},

	scrollToFragment() {
		const hash = window.location.hash;
		// using hash directly in querySelector can cause issues with special characters
		const escapedHash = hash.replace(/^#(\d)/, "#\\3$1 ");
		if (hash) {
			const targetItem = document.querySelector(escapedHash);
			if (targetItem?.classList?.contains("accordion-item")) {
				targetItem.scrollIntoView({ behavior: "smooth", block: "start" });
				this.openItem(targetItem);
			}
		}
	},

	toggleItem: (event) => {
		const accordionItem = event.currentTarget.parentElement;
		const accordionItemIsSelected = accordionItem.classList.contains(
			"accordion-item--selected",
		);
		const accordion = accordionItem.parentElement;

		if (!accordionItemIsSelected) {
			//* if it's not a multi accordion stick to default behaviour (close other opened items)
			if (accordion.getAttribute("data-mode") !== "multi") {
				const selectedItem = accordion.querySelector(
					".accordion-item--selected",
				);
				if (selectedItem) Accordion.closeItem(selectedItem);
			}
			//* open the item
			Accordion.openItem(accordionItem);
		} else {
			//* close current item (if it was opened)
			Accordion.closeItem(accordionItem);
		}
	},
};

export default Accordion;
